// Section 4 phase 9 (decay), Sections 7, 9 and 20: buildings wear, pay upkeep and freeze or
// thaw (buildings.ts), stocks spoil, the 12-season resource history rolls, fragility and the
// per-season series are recorded, and old reports are compacted. The Ledger is accumulated at
// the end of the steady phase, after the loss check (ADR-0017).
import type { Phase } from '../../core/types';
import { maintainBuildings } from './buildings';
import { compactHistory } from './history';
import { recordHistory, recordSeries } from './series';
import { spoilStocks } from './spoilage';

export const decayPhase: Phase = {
  id: 'decay',
  reads: ['history', 'buildings', 'stocks', 'people', 'seedReserved', 'options'],
  writes: [
    'history',
    'historySummaries',
    'buildings',
    'stocks',
    'seedReserved',
    'resourceHistory',
    'series',
    'currentReport',
  ],
  projection: 'run',
  run(ctx) {
    maintainBuildings(ctx);
    spoilStocks(ctx);
    recordHistory(ctx);
    recordSeries(ctx);
    compactHistory(ctx);
    return 'done';
  },
};
